export default function genererLigneOd() {
  return {
    libelle: null,
    compte: null,
    debit: 0,
    credit: 0,
    compteAuxiliaire: null,
    reference: null,
    ligneCompteTva: false,
  };
}
